import React from "react";
import Styles from "./userCard.module.css";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Button, Menu, MenuItem, Card } from "@mui/material";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import ReassignModal from "../../Modals/ReassignFos/ReassignModal";
import { useState } from "react";

function UserCard({
  data,
  actionStyles,
  acceptFos,
  rejectFos,
  reassignFos,
  tabValue,
  currentCpId,
  setConfirmationMsg,
  setSelectedOldFos,
}) {
  function reassign(e) {
    setOpenReassignModal(true);
  }
  const [openreassignModal, setOpenReassignModal] = useState(false);
  console.log(data);
  TimeAgo.setDefaultLocale(en.locale);
  TimeAgo.addLocale(en);
  console.log(tabValue);
  return (
    <>
      {window.innerWidth > 820 && (
        <Card className={Styles.userCard}>
          <div className={Styles.head}>
            <div className={Styles.nm}>
              <div className={Styles.pref}>{data.name[0]}</div>
              <div className={Styles.title}>
                <div className={Styles.name}>{data.name}</div>
                <div className={Styles.fosId}>
                  {"FOSID" +
                    data.fosDisplayId.replace(
                      data.fosDisplayId.substring(8, 12),
                      "-" + data.fosDisplayId.substring(8, 12)
                    )}
                </div>
              </div>
            </div>
            <div>
              <ReactTimeAgo
                style={{ fontSize: "1.2rem" }}
                date={data?.last_updated_at ?? data?.created_at}
                locale="en-US"
              />
            </div>
            {tabValue !== "reassign" && (
              <div className={Styles.status}>
                {data.approvalStatus === "pending" && (
                  <LeadStatusChip
                    style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                    label={data.approvalStatus}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  />
                )}
                {data.approvalStatus === "approved" && (
                  <LeadStatusChip
                    style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                    label={data.approvalStatus}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  />
                )}
                {data.approvalStatus === "rejected" && (
                  <LeadStatusChip
                    style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                    label={data.approvalStatus}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  />
                )}
                {data.approvalStatus === "resubmitted" && (
                  <LeadStatusChip
                    style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                    label={data.approvalStatus}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  />
                )}
              </div>
            )}
          </div>
          <div className={Styles.wrapperPanAadhar}>
            {/* <div> */}
            {data.KycDocuments.map((el) => {
              return (
                <>
                  <div className={Styles.kycDocLabel}>
                    {el.docType === "PanCard" && "PAN"}
                    {el.docType === "AadharCard" && "Aadhar"}:
                    <span className={Styles.kycDocValues}>{el.docNumber}</span>
                  </div>
                  {/* <div className={Styles.kycDocValue}></div> */}
                </>
              );
            })}
            {/* </div>
    <div className={Styles.fosContact}> */}
            <div className={Styles.phone}>
              Phone:{" "}
              <span className={Styles.kycDocValues}>+{data.contactNumber}</span>
            </div>
            <div className={Styles.email}>
              Email: <span className={Styles.kycDocValues}>{data.email}</span>
            </div>
            {/* </div> */}
          </div>
          <div className={Styles.fosBody}>
            {/* <div className={Styles.fosContact}>
      <div className={Styles.phone}>+{data.contactNumber}</div>
      <div className={Styles.email}>{data.email}</div>
    </div> */}
            <div className={Styles.wrapperCreatedAt}>
              <div>
                <CalendarTodayOutlinedIcon
                  style={{ color: "#1D2939", verticalAlign: "middle" }}
                />
              </div>
              <div className={Styles.fosId}>Created At:</div>
              <div className={Styles.fosId}>
                {new Date(data.created_at).toDateString()},{" "}
                {new Date(data.created_at).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
            </div>
            {(data.approvalStatus === "approved" ||
              ((data.approvalStatus === "resubmitted" ||
                data.approvalStatus === "rejected") &&
                data.totalLeads > 0)) && (
              <div className={Styles.leadCounts}>
                <div className={Styles.count}>
                  <div className={Styles.countLabel}>Total Leads</div>
                  <div className={Styles.countValue}>{data.totalLeads}</div>
                </div>
                <div className={Styles.count}>
                  <div className={Styles.countLabel}>Site Visit</div>
                  <div className={Styles.countValue}>
                    {data.totalSiteVisits}
                  </div>
                </div>
                <div className={Styles.count}>
                  <div className={Styles.countLabel}>Allotment</div>
                  <div className={Styles.countValue}>
                    {data.totalAllotments}
                  </div>
                </div>
                {/* <div className={Styles.count}>
            <div className={Styles.countLabel}>Agreement</div>
            <div className={Styles.countValue}>{data.totalAgreement}</div>
          </div> */}
              </div>
            )}
            {data?.previousCPEName && (
              <div className={Styles.prevCp}>
                Previous CP:{" "}
                <span className={Styles.kycDocValues}>
                  {data?.previousCPEName}
                </span>
              </div>
            )}
            <div className={Styles.actions} styles={actionStyles}>
              {data.approvalStatus !== "approved" && tabValue !== 'reassign' && (
                <Button
                  onClick={acceptFos}
                  variant="contained"
                  sx={{
                    fontFamily: "Inter-Regular",
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "1.4rem",
                    lineHeight: "2rem",
                    background: "#007FFF !important",
                    padding: "1.05rem 3rem !important",
                    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                    borderRadius: "8px",
                  }}
                >
                  Accept
                </Button>
              )}
              {data.approvalStatus !== "rejected" && tabValue !== 'reassign' && (
                <Button
                  onClick={rejectFos}
                  variant="outlined"
                  sx={{
                    fontFamily: "Inter-Regular",
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "1.4rem",
                    lineHeight: "2rem",
                    border: "1px solid #D0D5DD !important",
                    color: "#344054",
                    padding: "1.05rem 3rem !important",
                    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                    borderRadius: "8px",
                  }}
                >
                  Reject
                </Button>
              )}
              {tabValue === 'reassign' &&
                (data.totalLeads > 0 ? (
                  <Button
                    onClick={(e) => {
                      setSelectedOldFos(data.fosId);
                      reassign(e);
                    }}
                    variant="contained"
                    sx={{
                      fontFamily: "Inter-Regular",
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      background: "#007FFF !important",
                      padding: "1.05rem 3rem !important",
                      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                      borderRadius: "8px",
                    }}
                  >
                    Reassign
                  </Button>
                ) : (
                  <span className={Styles.noLeadsMessage}>
                    No leads to reassign.
                  </span>
                ))}
            </div>
          </div>
          {/* <div className={Styles.wrapperCreatedAt}>
      <div>
        <CalendarTodayOutlinedIcon
          style={{ color: "#1D2939", verticalAlign: "middle" }}
        />
      </div>
      <div className={Styles.fosId}>Created At:</div>
      <div className={Styles.fosId}>
        {new Date(data.created_at).toDateString()},{" "}
        {new Date(data.created_at).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })}
      </div>
    </div> */}
        </Card>
      )}
      {window.innerWidth < 820 && (
        <Card className={Styles.userCard}>
          <div className={Styles.head}>
            <div className={Styles.nm}>
              <div className={Styles.pref}>{data.name[0]}</div>
              <div className={Styles.title}>
                <div className={Styles.name}>{data.name}</div>
                <div className={Styles.fosId}>
                  {"FOSID" +
                    data.fosDisplayId.replace(
                      data.fosDisplayId.substring(8, 12),
                      "-" + data.fosDisplayId.substring(8, 12)
                    )}
                </div>
              </div>
            </div>
          </div>
          <div className={Styles.status_update_at}>
            <div className={Styles.status}>
              {data.approvalStatus === "pending" && (
                <LeadStatusChip
                  style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                  label={data.approvalStatus}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              )}
              {data.approvalStatus === "approved" && (
                <LeadStatusChip
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  label={data.approvalStatus}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              )}
              {data.approvalStatus === "rejected" && (
                <LeadStatusChip
                  style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                  label={data.approvalStatus}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              )}
              {data.approvalStatus === "resubmitted" && (
                <LeadStatusChip
                  style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                  label={data.approvalStatus}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              )}
            </div>
            <div>
              <ReactTimeAgo
                style={{ fontSize: "1.2rem" }}
                date={data?.last_updated_at ?? data?.created_at}
                locale="en-US"
              />
            </div>
          </div>
          <div className={Styles.wrapperPanAadhar}>
            {/* <div> */}
            {data.KycDocuments.map((el) => {
              return (
                <>
                  <div className={Styles.kycDocLabel}>
                    {el.docType === "PanCard" && "PAN"}
                    {el.docType === "AadharCard" && "Aadhar"}:
                    <span className={Styles.kycDocValues}>{el.docNumber}</span>
                  </div>
                  {/* <div className={Styles.kycDocValue}></div> */}
                </>
              );
            })}
          </div>
          <div className={Styles.fosBody}>
            <div className={Styles.fosContact}>
              <div className={Styles.phone}>
                Phone:
                <span className={Styles.kycDocValues}>
                  +{data.contactNumber}
                </span>
              </div>
              <div className={Styles.email}>
                Email:<span className={Styles.kycDocValues}>{data.email}</span>
              </div>
            </div>
            {(data.approvalStatus === "approved" ||
              ((data.approvalStatus === "resubmitted" ||
                data.approvalStatus === "rejected") &&
                data.totalLeads > 0)) && (
              <div className={Styles.leadCounts}>
                <div className={Styles.count}>
                  <div className={Styles.countLabel}>Total Leads</div>
                  <div className={Styles.countValue}>{data.totalLeads}</div>
                </div>
                <div className={Styles.count}>
                  <div className={Styles.countLabel}>Site Visit</div>
                  <div className={Styles.countValue}>
                    {data.totalSiteVisits}
                  </div>
                </div>
                <div className={Styles.count}>
                  <div className={Styles.countLabel}>Allotment</div>
                  <div className={Styles.countValue}>
                    {data.totalAllotments}
                  </div>
                </div>
                {/* <div className={Styles.count}>
            <div className={Styles.countLabel}>Agreement</div>
            <div className={Styles.countValue}>{data.totalAgreement}</div>
          </div> */}
              </div>
            )}
            {data?.previousCPEName && (
              <div className={Styles.prevCp}>
                Previous CP:{" "}
                <span className={Styles.kycDocValues}>
                  {data?.previousCPEName}
                </span>
              </div>
            )}
            <div className={Styles.created_actions_wrap}>
              <div className={Styles.wrapperCreatedAt}>
                <div>
                  <CalendarTodayOutlinedIcon
                    style={{ color: "#1D2939", verticalAlign: "middle" }}
                  />
                </div>
                {/* <div className={Styles.fosId}>Created At:</div> */}
                <div className={Styles.fosId}>
                  {new Date(data.created_at).toDateString()},{" "}
                  {new Date(data.created_at).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </div>
              </div>
              <div className={Styles.actions} styles={actionStyles}>
                {data.approvalStatus !== "approved" && tabValue !== 'reassign'&& (
                  <Button
                    onClick={acceptFos}
                    variant="contained"
                    sx={{
                      fontFamily: "Inter-Regular",
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      background: "#007FFF !important",
                      padding: "1.05rem 3rem !important",
                      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                      borderRadius: "8px",
                    }}
                  >
                    Accept
                  </Button>
                )}
                {data.approvalStatus !== "rejected" && tabValue !== 'reassign' && (
                  <Button
                    onClick={rejectFos}
                    variant="outlined"
                    sx={{
                      fontFamily: "Inter-Regular",
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      border: "1px solid #D0D5DD !important",
                      color: "#344054",
                      padding: "1.05rem 3rem !important",
                      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                      borderRadius: "8px",
                    }}
                  >
                    Reject
                  </Button>
                )}
                {tabValue === 'reassign' &&
                  (data.totalLeads > 0 ? (
                    <Button
                      onClick={(e) => {
                        setSelectedOldFos(data.fosId);
                        reassign(e);
                      }}
                      variant="contained"
                      sx={{
                        fontFamily: "Inter-Regular",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                        background: "#007FFF !important",
                        padding: "1.05rem 3rem !important",
                        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                        borderRadius: "8px",
                      }}
                    >
                      Reassign
                    </Button>
                  ) : (
                    <span className={Styles.noLeadsMessage}>
                      No leads to reassign.
                    </span>
                  ))}
              </div>
            </div>
          </div>
          {/* <div className={Styles.wrapperCreatedAt}>
            <div>
              <CalendarTodayOutlinedIcon
                style={{ color: "#1D2939", verticalAlign: "middle" }}
              />
            </div>
            <div className={Styles.fosId}>Created At:</div>
            <div className={Styles.fosId}>
              {new Date(data.created_at).toDateString()},{" "}
              {new Date(data.created_at).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          </div> */}
        </Card>
      )}
      <ReassignModal
        open={openreassignModal}
        handleClose={() => setOpenReassignModal(false)}
        reassign={(fos) => {
          setOpenReassignModal(false);
          console.log(fos);
          reassignFos(fos);
        }}
        data={data}
        currentCpId={currentCpId}
        setConfirmationMsg={setConfirmationMsg}
      />
    </>
  );
}

export default UserCard;
